/* eslint-disable */
import { getRoleLabel, getStellaEnv } from './helpers';
export const loadIntercom = (
  userDetails,
  environment,
  rbacEnabled,
  newApp
) => {
  const env = getStellaEnv();
  let APP_ID;
  if (env === 'production') {
    APP_ID = newApp ? 'gudxnvpg' : 'fote1mq2';
  } else {
    APP_ID = newApp ? 'yscj2hka' : 'ibkilz172';
  }
  const {
    name,
    email,
    company = {},
    isAdmin,
    isManager,
    isCompanyAdmin,
    intercomEmployeeHash,
    customRole = {},
  } = userDetails;
  let userRole =
    rbacEnabled && customRole.roleTemplate
      ? customRole.roleTemplate
      : getRoleLabel(isAdmin, isManager, isCompanyAdmin);

  if (newApp) {
    window.intercomSettings = {
      app_id: APP_ID,
      name,
      email,
      user_id: email,
      agent_connect_role: userRole,
      agent_connect_rbac_role: customRole.roleName,
      product: 'Agent Connect',
      user_hash: intercomEmployeeHash,
      url_name: company.url,
      company: {
        id: company.rootUrl,
        name: company.name,
        url_name: company.url,
        product: 'Agent Connect',
        data_center: environment
      },
      hide_default_launcher: true,
    };
  } else {
    window.intercomSettings = {
      app_id: APP_ID,
      name,
      email,
      user_id: email,
      role: userRole,
      'role name': customRole.roleName,
      product: 'Stella Connect',
      user_hash: intercomEmployeeHash,
      company: {
        id: company.url,
        name: company.name,
        url: company.url,
        product: 'StellaConnect',
      },
      hide_default_launcher: true,
    };
  }
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + APP_ID;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
  const contactUsElem = document.getElementById('contact-us');
  contactUsElem &&
    contactUsElem.addEventListener('click', () => {
      Intercom('update', {
        hide_default_launcher: false,
      });
      Intercom('show');
    });

  document.getElementById('logout').addEventListener('click', () => {
    Intercom('shutdown');
  });
  return Intercom;
};
